import { createFileRoute } from '@tanstack/react-router';
import { useContext } from 'react';

import { AnalyticsPage } from '../../../../analytics/AnalyticsPage.js';
import { usePermissions } from '../../../../api/me.js';
import { PageHeading } from '../../../../components/PageHeading.js';
import { PermissionDeniedPage, WebsiteNotFoundPage } from '../../../../components/SectionStates.js';
import { WebsiteStatusContext } from '../../../../components/WebsiteSection.js';

/**
 * `/websites/:websiteId/analytics`: the website's analytics
 * (features/website-analytics). Needs the analytics permission.
 */
export const Route = createFileRoute('/_app/websites/$websiteId/analytics')({
  component: AnalyticsRoute,
});

const TITLE = 'Analytics';

function AnalyticsRoute() {
  const { websiteId } = Route.useParams();
  const permissions = usePermissions();
  const websiteStatus = useContext(WebsiteStatusContext);

  if (!permissions.includes('analytics')) {
    return <PermissionDeniedPage title={TITLE} permission="analytics" />;
  }
  if (websiteStatus === 'not-found') return <WebsiteNotFoundPage title={TITLE} />;

  return (
    <>
      <PageHeading documentTitle={TITLE}>{TITLE}</PageHeading>
      <AnalyticsPage websiteId={websiteId} />
    </>
  );
}
